import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const isAuthUser = true;

  if (!isAuthUser) {
    return <Navigate to={"Page.SIGN_IN"} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
